var exports = {
  "o": "categoryCardImage__ekrVzZ",
  "n": "categoryCard__PsanBj",
};

module.exports = exports;
